var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidesIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66737 11.9215H9.55983L11.1756 13.5372C11.6639 14.0255 12.4555 14.0255 12.943 13.5372L14.5588 11.9215H15.3329C16.2537 11.9215 16.9995 11.1757 16.9995 10.2549V3.58847C16.9995 2.66768 16.2537 1.92188 15.3329 1.92188H8.66653C7.74574 1.92188 6.99994 2.66768 6.99994 3.58847V10.2549C6.99994 11.1757 7.74657 11.9215 8.66737 11.9215ZM11.1673 3.58847H12.8339V5.25507H11.1673V3.58847ZM11.1673 6.08837H12.8339V10.2549H11.1673V6.08837ZM22.0001 5.2959V19.3237L12.0006 21.1419L2.00098 19.3237V5.2959C2.00098 4.5526 2.32846 3.85346 2.89927 3.37681C3.46925 2.901 4.21338 2.70184 4.94752 2.83684L5.39917 2.946C5.35834 3.15432 5.33417 3.36848 5.33417 3.58931V10.2557C5.33417 12.094 6.82911 13.5889 8.66737 13.5889H8.86986L9.99814 14.7172C10.3365 15.0547 10.7406 15.2797 11.1673 15.4163V19.2962L12.0006 19.4478L12.8339 19.2962V15.4513C13.3047 15.3222 13.753 15.0855 14.1221 14.7163L15.2504 13.5881H15.3346C17.1728 13.5881 18.6678 12.0931 18.6678 10.2549V3.58847C18.6678 3.36765 18.6436 3.15266 18.6028 2.94433L19.0061 2.846C19.7869 2.70351 20.531 2.89933 21.1027 3.37598C21.6743 3.85263 22.001 4.55177 22.001 5.29507L22.0001 5.2959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesIcons);
export default __webpack_public_path__ + "static/media/guidesIcons.88795991943355e9bcc9e10819fca0de.svg";
export { ForwardRef as ReactComponent };